export enum CaiInputTypesEnum {
  DEFAULT = "default",
  DECIMAL = "decimal",
  NUMERIC = "digits",
  ALPHABET = "alphabet",
  ALPHANUMERIC = "alphanumeric",
}
